export default "__VITE_ASSET__DOW7AeTr__"